import React from 'react';
import { withSvg } from '../Svg';

const NotStarted = () => (
    <circle cx="12" cy="12" r="11.5" fill="white" stroke="white"/>
);

export default withSvg(24, 24)(NotStarted);